<template>
    <div class="flex justify-between">
        <button
            @click="$emit('back')"
            type="button"
            :aria-label="$t('actions.back')"
            class="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium text-white bg-minplan-greybeige hover:bg-minplan-lightgreybeige focus:outline-none uppercase"
        >
            <ArrowLeftIcon
                class="md:mr-2 h-5 w-5 text-white md:text-minplan-darkgreybeige"
            />
            <span class="hidden md:inline font-bold">{{ $t("actions.back") }}</span>
        </button>

        <div class="flex gap-3">
            <secondary-button
                type="button"
                :disabled="processing"
                :aria-label="$t('actions.add')"
                @click="$emit('add')"
            >
                <PlusSmIcon class="md:mr-2 h-5 w-5 text-minplan-darkgreybeige" />
                <span class="hidden md:inline">{{ $t("actions.add") }}</span>
            </secondary-button>
            <primary-button
                :class="{ 'opacity-25': processing }"
                :disabled="processing"
                class="bg-lime-600 hover:bg-lime-500"
            >
                <CheckIcon class="md:mr-2 h-5 w-5 text-lime-900" />
                {{ $t("actions.save") }}
            </primary-button>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import SecondaryButton from "@/Jetstream/SecondaryButton";
import { ArrowLeftIcon, CheckIcon, PlusSmIcon } from "@heroicons/vue/outline";

// Leiste der Themenmaske, steht oben UND unter der Liste (ein Markup, zwei Einsatzorte).
// Der Speichern-Knopf ist ein Submit-Knopf und löst das `submit` des umgebenden <form> aus.
export default defineComponent({
    props: {
        processing: Boolean,
    },
    emits: ["back", "add"],
    components: { PrimaryButton, SecondaryButton, ArrowLeftIcon, CheckIcon, PlusSmIcon },
});
</script>
